"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GovModule = void 0;
const tx_1 = require("../codec/cosmos/gov/v1/tx");
const util_1 = require("../util");
const amino_1 = require("@cosmjs/amino");
const long_1 = __importDefault(require("long"));
const base_1 = __importDefault(require("./base"));
class GovModule extends base_1.default {
    submit(proposalMsg, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const { initialDeposit, messages, metadata, title, summary, proposer } = proposalMsg;
            const finalProposalMsg = tx_1.MsgSubmitProposal.fromPartial({
                initialDeposit,
                messages,
                metadata,
                title,
                summary,
                proposer,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgGovSubmitProposal,
                value: finalProposalMsg,
            }, opts);
        });
    }
    deposit(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgDeposit.fromPartial({
                proposalId: new long_1.default(params.proposalId),
                depositor: wallet.bech32Address,
                amount: amino_1.coins(params.amount, params.denom),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgDeposit,
                value,
            }, opts);
        });
    }
    vote(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgVote.fromPartial({
                proposalId: new long_1.default(params.proposalId),
                voter: wallet.bech32Address,
                option: params.option,
                metadata: params.metadata,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgVote,
                value,
            }, opts);
        });
    }
}
exports.GovModule = GovModule;
